import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import type { DashboardFailure } from "./TeamDashboard";

// Короткие причины падения разбора для команды. `Record` по union из контракта: новый код не
// соберётся без подписи.
export const FAILURE_LABELS: Record<DashboardFailure["code"], MessageDescriptor> = {
  match_not_found: msg`Match not found`,
  match_wait_timeout: msg`Match never appeared in time`,
  match_too_old: msg`Match too old`,
  deadlock_api_unavailable: msg`deadlock-api unavailable`,
  invalid_match_data: msg`Broken match data`,
  unsupported_game_mode: msg`Unsupported game mode`,
  internal_error: msg`Internal error`,
};
